module.exports = __webpack_public_path__ + "static/media/VectorQuote.e24080d1.svg";